import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/format";
import { Card, Loading, EmptyState, PageHeader, Button } from "@/components/common";

const LEVEL = {
  warning: "border-l-amber-400 bg-amber-50/40",
  danger: "border-l-rose-400 bg-rose-50/40",
  error: "border-l-rose-400 bg-rose-50/40",
  success: "border-l-emerald-400 bg-emerald-50/40",
  info: "border-l-sky-400 bg-sky-50/40",
};

export default function Notifications() {
  const { branch } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get("/notifications", branch ? { branch_id: branch.id } : {}).then(setData).finally(() => setLoading(false));
  };
  useEffect(load, [branch]);
  const markRead = async () => { await api.post("/notifications/read"); load(); };

  if (loading) return <Loading />;
  return (
    <>
      <PageHeader title="Notifikasi" subtitle={data ? `${data.pending_approvals} menunggu approval` : ""} icon={Bell}
        actions={<Button variant="outline" onClick={markRead}><CheckCheck size={16} /> Tandai dibaca</Button>} />
      {!data?.items?.length ? <EmptyState icon={Bell} title="Tidak ada notifikasi" message="Semua sudah beres." /> : (
        <div className="space-y-2">
          {data.items.map((it) => (
            <Card key={it.id} className={`p-4 border-l-4 ${LEVEL[it.level] || LEVEL.info} cursor-pointer hover:shadow-sm`} onClick={() => it.href && nav(it.href.split("?")[0])} data-testid={`notif-${it.type}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-medium text-slate-800">{it.title}</div>
                  <div className="text-sm text-slate-500 mt-0.5">{it.body}</div>
                </div>
                <span className="text-xs text-slate-400 whitespace-nowrap">{fmtDateTime(it.at)}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
